// src/hooks/useNavigateAndScroll.js
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useNavigateAndScroll() {
  const navigate = useNavigate();

  return useCallback(
    (to, options = {}) => {
      // first navigate…
      navigate(to, options);
      // …then scroll to top
      window.scrollTo(0, 0);
    },
    [navigate]
  );
}
